/**
 * A strictly-monotonic ISO clock, for any module that stamps `updated_at`.
 *
 * The same reasoning as the groceries `db/clock.ts`: last-write-wins breaks ties
 * on the device, so two edits from one phone in the same millisecond would
 * compare equal and the second would be silently dropped — which is exactly what
 * a thumb tapping twice produces. This never returns the same value twice: it
 * follows the wall clock and advances a millisecond of its own when the wall
 * clock has not moved.
 *
 * Each module using this shares one monotonic sequence, which is harmless — a
 * module's rows only ever compare against its own — and keeps the guarantee
 * within the module absolute.
 */
let last = 0;

export function stamp(): string {
  const now = Date.now();
  last = now > last ? now : last + 1;
  return new Date(last).toISOString();
}
